import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { AuthGuardService, Claims, ModuleNames } from "@digic/shared";
import { DashboardComponent } from "./dashboard/dashboard.component";


const routerOptions: ExtraOptions = {
  onSameUrlNavigation: "reload",
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  scrollOffset: [0, 64]
};

const routes: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    data: { title: "dApp - Dashboard" },
  },
  { path: "**", redirectTo: "dashboard"},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
